'use client';

import { c as _c } from "react/compiler-runtime";
import * as TabsPrimitive from '@radix-ui/react-tabs';
import * as React from 'react';
import { cn } from '@/lib/utils';
const UnderlineTabsTrigger = t0 => {
  const $ = _c(10);
  let className;
  let props;
  let ref;
  if ($[0] !== t0) {
    ({
      className,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = ref;
  } else {
    className = $[1];
    props = $[2];
    ref = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("w-fit px-3 py-1.5 min-h-[35px] flex items-center justify-center", "text-sm font-base text-zinc-400 hover:text-zinc-100", "aria-selected:text-zinc-200", "relative after:absolute after:bottom-0 after:left-0 after:right-0", "after:bg-transparent hover:after:bg-zinc-700 aria-selected:after:bg-white", "after:h-[1px] aria-selected:after:h-[1.5px]", "bg-transparent shadow-none rounded-none data-[state=active]:bg-transparent", "transition-all focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", "disabled:pointer-events-none disabled:opacity-50 cursor-pointer", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props || $[7] !== ref || $[8] !== t1) {
    t2 = <TabsPrimitive.Trigger ref={ref} className={t1} {...props} />;
    $[6] = props;
    $[7] = ref;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
UnderlineTabsTrigger.displayName = 'UnderlineTabsTrigger';
export { UnderlineTabsTrigger };